import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-713866ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 border radio-group" }

import { computed } from "vue";
import { requiredRule } from "@/utils/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
  modelValue: null,
  label: { type: String, default: "" },
  icon: String,
  options: null,
  rules: null,
  required: Boolean,
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;




const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const rules = computed(() =>
  props.required ? [...(props.rules || []), requiredRule] : props.rules
);

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_radio_group, {
          label: __props.label,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          rules: rules.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createBlock(_component_v_radio, {
                key: option.value,
                label: option.label,
                value: option.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label", "modelValue", "rules"])
      ])
    ]),
    _: 1
  }))
}
}

})